<template>
  <div class="navigator" :class="{ mobile: isMobile }">
    <button class="btn" @click="call">
      <font-awesome-icon :icon="['fas', 'phone']" />
      <span v-if="isMobile">전화</span>
    </button>
    <router-link to="/map" class="btn">
      <font-awesome-icon :icon="['fas', 'location-dot']" />
      <span v-if="isMobile">오시는길</span>
    </router-link>
    <button class="btn" @click="scrollToTop">
      <font-awesome-icon :icon="['fas', 'angle-up']" />
      <span v-if="isMobile">TOP</span>
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
const call = () => {
  window.location.href = "tel:0232850201";
};
const isMobile = ref(false);
const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};
onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style scoped>
.navigator {
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  z-index: 9999;
}
.navigator.mobile {
  bottom: 0;
  right: 0;
  left: 0;
  flex-direction: row;
  justify-content: space-around;
  background: #222;
  padding: 10px 0;
}
.btn {
  background: #11101a;
  color: white;
  border: none;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.navigator.mobile .btn {
  width: auto;
  height: auto;
  padding: 0 12px;
  border-radius: 0;
  font-size: 1rem;
  background: none;
  color: white;
  box-shadow: none;
  flex-direction: row;
  gap: 6px;
}
</style>
